import { PRODUCT_INQUIRY_FIELD_NAMES } from "./laundrySheetInquiryFields";

const subjectText = (value, fallback) => {
  const text = typeof value === "string" ? value.replace(/\s+/g, " ").trim() : "";
  return text || fallback;
};

export const createInquirySubject = (formData) => {
  const customerName = subjectText(formData.get("name"), "Anonymous customer");
  const productName = subjectText(
    formData.get(PRODUCT_INQUIRY_FIELD_NAMES.productName),
    "General product inquiry"
  );
  // Generate all 64 random bits anew for each submission, including repeat inquiries.
  const randomValues = window.crypto.getRandomValues(new Uint32Array(2));
  const submissionId = Array.from(randomValues, (value) => value.toString(36).padStart(7, "0"))
    .join("")
    .toUpperCase();

  return `New Product Inquiry - ${customerName} - ${productName} - ${submissionId}`;
};
